import LeaveRecord from '@/api/hr/leave-record'
import Employee from '@/api/hr/employee'
import LeaveSubItem from '@/api/hr/leave-sub-item'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  leaveTypes: [],
  times: [],
  leaveSubItems: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_EMPLOYEES(state, data) {
    state.employees = data
  },
  RECEIVE_LEAVE_TYPES(state, data) {
    state.leaveTypes = data
  },
  RECEIVE_TIMES(state, data) {
    state.times = data
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  RECEIVE_LEAVE_SUB_ITEMS(state, data) {
    state.leaveSubItems = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return LeaveRecord.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return LeaveRecord.store(data)
  },

  update(context, { id, data }) {
    return LeaveRecord.update(id, data)
  },
  destroy(context, data) {
    return LeaveRecord.destroy(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await LeaveRecord.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      include: 'logical_position,shift',
      fields: {
        hris_employee_profiles:
          'employee_id,employee_name_en,employee_name_kh,card_id,sex,phone,date_of_birth,position_id,shift_id,photo',
        logical_position: 'position_id,position_name_en',
        shift: 'shift_id,shift_name,shift_type'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchLeaveSubItems(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_leave_type_sub_items: 'leave_sub_item_id,leave_sub_item'
      },
      ...attributes
    }

    return LeaveSubItem.get({ params }).then(response => {
      context.commit('RECEIVE_LEAVE_SUB_ITEMS', response.data)
      return Promise.resolve(response)
    })
  },

  async getTimeFromTo(context, data) {
    if (!data.employee_id || !data.date_from || !data.date_to) return

    let response = await LeaveRecord.getTime(data)
    context.commit('RECEIVE_TIMES', response.data)
  },

  getTotal(context, data) {
    return LeaveRecord.getTotalDay(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.leaveTypes.length > 0) {
      let response = await LeaveRecord.leaveType()
      context.commit('RECEIVE_LEAVE_TYPES', response.data)
    }
  }
}
